// extracted by mini-css-extract-plugin
export default {"not-found":"NotFound_not-found__FM9nB","not-found__img":"NotFound_not-found__img__ktnV7"};